import { render } from "./boxInsertionTeaserItem.vue?vue&type=template&id=2f3ae158"
import script from "./boxInsertionTeaserItem.vue?vue&type=script&lang=js"
export * from "./boxInsertionTeaserItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__